import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { BaseSchema } from 'yup';
import { ObjectShape } from 'yup/lib/object';
import {
  isPostalCodeValid,
  isPostalCodeValidWithoutOverseas,
} from '../services/validation';
import {
  FIELD_COUNTRY_MAX_FR,
  FIELD_COUNTRY_MAX_UK,
} from 'settings/constraints';
import { POSTCODE_UK_REGEX } from 'settings/regex';

export function validationSchema(isUk: boolean, t: TFunction): BaseSchema {
  return Yup.object().shape({
    street: Yup.string()
      .required(t('LABEL_SCHEMA_STREET_REQUIRED', { ns: 'translation' }))
      .min(2, t('LABEL_ERROR_NAME_WAY_LENGTH', { ns: 'translation' }))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_NAME_WAY_LENGTH', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, {
        excludeEmptyString: true,
        message: t('LABEL_ERROR_CARAC', { ns: 'translation' }),
      }),
    nameComplement: Yup.string()
      .min(2, t('LABEL_ERROR_NAME_COMPLEMENT_LENGTH', { ns: 'translation' }))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_NAME_COMPLEMENT_LENGTH', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, {
        excludeEmptyString: true,
        message: t('LABEL_ERROR_CARAC', { ns: 'translation' }),
      }),
    nameAddress: Yup.string()
      .min(2, t('LABEL_ERROR_NAME_ADDRESS_LENGTH', { ns: 'translation' }))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_NAME_ADDRESS_LENGTH', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, {
        excludeEmptyString: true,
        message: t('LABEL_ERROR_CARAC', { ns: 'translation' }),
      }),
    saidPlace: Yup.string()
      .min(2, t('LABEL_ERROR_NAME_SAID_PLACE_LENGTH', { ns: 'translation' }))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_NAME_SAID_PLACE_LENGTH', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, {
        excludeEmptyString: true,
        message: t('LABEL_ERROR_CARAC', { ns: 'translation' }),
      }),
    postalCode: Yup.string()
      .required(t('LABEL_ERROR_POSTCODE_REQUIRED', { ns: 'translation' }))
      .min(
        isUk ? 6 : 5,
        t('LABEL_ERROR_POSTCODE_LENGTH', { ns: 'translation' })
      )
      .max(
        isUk ? 8 : 5,
        t('LABEL_ERROR_POSTCODE_LENGTH', { ns: 'translation' })
      )
      .test(
        'postcode',
        t('LABEL_ERROR_POSTCODE_REGEX', { ns: 'translation' }),
        function (value) {
          return !value
            ? true
            : isUk
            ? POSTCODE_UK_REGEX.test(value)
            : isPostalCodeValid(value);
        }
      ),
    city: Yup.string()
      .required(t('LABEL_SCHEMA_TOWN', { ns: 'translation' }))
      .max(
        isUk ? FIELD_COUNTRY_MAX_UK : FIELD_COUNTRY_MAX_FR,
        t('LABEL_ERROR_CITY_MAX', { ns: 'translation' })
      )
      .matches(/^[^&]*$/, {
        excludeEmptyString: true,
        message: t('LABEL_ERROR_CARAC', { ns: 'translation' }),
      }),
  });
}

export function validationSchemaSecondary(
  isUk: boolean,
  t: TFunction
): BaseSchema {
  const baseSchema = validationSchema(isUk, t);
  const secondarySchema = baseSchema.clone() as Yup.ObjectSchema<{
    postalCode: ObjectShape[0];
  }>;

  secondarySchema.fields.postalCode = Yup.string()
    .required(t('LABEL_ERROR_POSTCODE_REQUIRED', { ns: 'translation' }))
    .min(isUk ? 6 : 5, t('LABEL_ERROR_POSTCODE_LENGTH', { ns: 'translation' }))
    .max(isUk ? 8 : 5, t('LABEL_ERROR_POSTCODE_LENGTH', { ns: 'translation' }))
    .test(
      'postcode',
      t('LABEL_ERROR_POSTCODE_REGEX', { ns: 'translation' }),
      function (value) {
        return !value
          ? true
          : isUk
          ? POSTCODE_UK_REGEX.test(value)
          : isPostalCodeValidWithoutOverseas(value);
      }
    );

  return secondarySchema;
}
